import { Media } from '@/models/media.model';
import { TranslationState } from '@/models/translation.model';
import { Address } from './info.model';
import { Category } from '@/models/category.model';
import { Contact } from '@/models/contact.model';
import { NEW_ID } from '@/util/constants';
import { User } from './user.model';

export enum ImpactArea {
  Local = 'local',
  National = 'national',
  Global = 'global',
}

export enum InitiativeStatus {
  Editing = 'editing', // created by content editor
  ReadyForReview = 'ready-for-review', // for review by content editor
  ReadyForPublishing = 'ready-for-publishing', // approved by content editor (can be published)
  Published = 'published', // approved by shift
}

export function getShortStatus(item: Initiative, status: InitiativeStatus) {
  switch (status) {
    case InitiativeStatus.Editing:
      return 'editing';
    case InitiativeStatus.ReadyForReview:
      return 'review';
    case InitiativeStatus.ReadyForPublishing:
      return 'publishing';
    case InitiativeStatus.Published:
      return item.published ? 'published' : 'user_published';
  }
}

export interface Initiative {
  id: number;
  publicUUID?: string;
  title: string;
  quizTitle: string;
  shortDescription: string;
  description: string;
  website: string;
  recommended: boolean;
  published: boolean;
  status: InitiativeStatus;
  favourite: number;
  address: Address;
  media: Media[];
  mainCategory: Category;
  categories: Category[];
  contacts: Contact[];
  impactArea: ImpactArea;
  translated?: TranslationState;
  createdByUser?: User;
}

export const impactAreaItems = [
  {
    title: 'Local',
    value: ImpactArea.Local,
  },
  {
    title: 'National',
    value: ImpactArea.National,
  },
  {
    title: 'Global',
    value: ImpactArea.Global,
  },
];

export const defaultInitiative: Initiative = {
  id: NEW_ID,
  publicUUID: '',
  title: '',
  quizTitle: '',
  shortDescription: '',
  recommended: false,
  favourite: 0,
  media: [],
  impactArea: ImpactArea.Local,
  description: '',
  published: false,
  status: InitiativeStatus.Editing,
  mainCategory: {
    id: NEW_ID,
    title: '',
    tileTitle: '',
    color: '',
    emoji: '',
    media: [],
    parentCategory: null,
    isContent: false,
    index: 0,
  },
  categories: [],
  contacts: [],
  website: '',
  address: {
    street: '',
    house_number: '',
    postal_code: '',
    city: '',
    country: 'NL',
    isSpecific: true,
    alternative: [],
  },
};
